import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import BasicButton from '../../Components/Button_Basic';
import Input from '../../Components/Input_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
import GridModal from '../../Components/Modal_Grid';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
// import "ag-grid-community/styles/ag-theme-quartz.css";

import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';
import { current } from '@reduxjs/toolkit';
function PM10010(props) {
    React.useEffect(() => {
        document.title = '발주서입력';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '구매관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>발주서입력</strong>" +
            '</h1>';
    }, []);
    const [modalToggle, setModalToggle] = React.useState(false);
    const [modalToggle1, setModalToggle1] = React.useState(false);
    const [modalToggle2, setModalToggle2] = React.useState(false);
    const [modalToggle3, setModalToggle3] = React.useState(false);
    const [modalToggle4, setModalToggle4] = React.useState(false);
    const [selectedRowData, setSelectedRowData] = React.useState(null);
    const [selectedModalData, setSelectedModalData] = React.useState(null);
    const [selectedRowData1, setSelectedRowData1] = React.useState(null);
    const [selectedModalData1, setSelectedModalData1] = React.useState(null);
    const [selectedModalData2, setSelectedModalData2] = React.useState(null);
    let no = 0;
    const [checkInputs, setCheckInputs] = React.useState({
        value: '',
        value1: '',
    });
    const [checkInputs1, setCheckInputs1] = React.useState({
        value: '',
        value2: '',
        value1: 0,
    });
    const [checkChanged, setCheckChanged] = React.useState([]);
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    const [savePoNo, setSavePoNo] = React.useState('');
    const [updateDate, setUpdateDate] = React.useState(new Date());

    //왼쪽 그리드 컬럼
    const columnDefs = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: 'poStusNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoSatusNm' && f.lanType === 'COL')[0].lanName
                    : '', //진행상태
            minWidth: 100,
            cellRenderer: Commons.CustomHeaderRenderer,
            // cellStyle: { color: "red" },
        },

        {
            field: 'poCreateDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProcessOrderDate' && f.lanType === 'COL')[0].lanName
                    : '', //발주일자
            minWidth: 100,
        },

        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래처명
            minWidth: 180,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            minWidth: 90,
        },
        {
            field: 'delivDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DueDate' && f.lanType === 'COL')[0].lanName
                    : '', //납기일
            minWidth: 100,
        },
        {
            field: 'reference',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Reference' && f.lanType === 'COL')[0].lanName
                    : '', //참조
            minWidth: 100,
        },
        {
            field: 'poNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProcessNo' && f.lanType === 'COL')[0].lanName
                    : '', //발주번호
            minWidth: 100,
        },
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '', //거래처코드
            minWidth: 120,
        },
        {
            field: 'poType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '', //결제유형
            minWidth: 120,
            hide: true,
        },
    ];
    const autoGroupColumnDef = React.useMemo(() => {
        return {
            minWidth: 300,
            cellRendererParams: {
                footerValueGetter: (params) => {
                    return 'Grand Total';
                },
            },
        };
    }, []);
    //오른쪽 그리드 컬럼
    const columnDefs1 = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            cellRenderer: (e) => {
                return !e.data ? 'TOTAL' : e.data.no;
            },
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'whCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_InWhCd' && f.lanType === 'COL')[0].lanName
                    : '', //입고창고
            editable: false,
            hide: true,
            // cellStyle: { textAlign: "center" },
        },
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_InWhCd' && f.lanType === 'COL')[0].lanName
                    : '', //입고창고
            editable: props.inputs.poStusNm === '입고완료' ? false : true,
            cellEditor: 'agSelectCellEditor',
            cellRenderer: (value) => {
                if (value == undefined || value == 'undefined' || value == null || !value) {
                    //value가 없을때
                } else {
                    if (!value.data) {
                        //value.data가 없을때
                    } else {
                        if (value.data.whNm == null) {
                        } else {
                            if (value.data.whNm.name != undefined) {
                                return (
                                    <div
                                        style={{
                                            color:
                                                value.data.whNm.name === '[부산][입고][B][IN-warehouse]' ||
                                                value.data.whNm.name === '[부산][B][생산][Production]'
                                                    ? 'orange'
                                                    : value.data.whNm.name === '[서울][입고][S][IN-warehouse]' ||
                                                      value.data.whNm.name === '[서울][S][생산][Production]'
                                                    ? 'green'
                                                    : value.data.whNm.name === '[베트남][입고][V][IN-warehouse]' ||
                                                      value.data.whNm.name === '[베트남][V][생산][Production]'
                                                    ? 'blue'
                                                    : value.data.whNm.name === '[중국][입고][C][入庫倉庫]' ||
                                                      value.data.whNm.name === '[중국][생산]生產倉庫'
                                                    ? 'red'
                                                    : '',
                                        }}
                                    >
                                        {value.data.whNm.name}
                                    </div>
                                );
                            } else {
                                return (
                                    <div
                                        style={{
                                            color:
                                                value.data.whNm === '[부산][입고][B][IN-warehouse]' ||
                                                value.data.whNm === '[부산][B][생산][Production]'
                                                    ? 'orange'
                                                    : value.data.whNm === '[서울][입고][S][IN-warehouse]' ||
                                                      value.data.whNm === '[서울][S][생산][Production]'
                                                    ? 'green'
                                                    : value.data.whNm === '[베트남][입고][V][IN-warehouse]' ||
                                                      value.data.whNm === '[베트남][V][생산][Production]'
                                                    ? 'blue'
                                                    : value.data.whNm === '[중국][입고][C][入庫倉庫]' ||
                                                      value.data.whNm === '[중국][생산]生產倉庫'
                                                    ? 'red'
                                                    : '',
                                        }}
                                    >
                                        {value.data.whNm}
                                    </div>
                                );
                            }
                        }
                    }
                }
            },

            cellEditorParams: {
                values: props.inputs.comboInwh,
                default: props.inputs.comboValue,
            },
            valueParser: (params) => {
                return props.inputs.comboValue;
            },
            valueFormatter: (params) => {
                if (params.value == undefined) {
                    return null;
                } else {
                    return params.value.name;
                }
            },
            cellStyle: { textAlign: 'center' },
            minWidth: 150,
        },

        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            cellRenderer: (e) => {
                return !e.data ? (
                    <a></a>
                ) : e.data.itemCd ? (
                    <span style={{ color: 'black' }}>{e.data.itemNm}</span>
                ) : (
                    <BasicButton name="설정하기" onClick={() => AuthGroupSettingClicked1(e)} />
                );
            },
            minWidth: 300,
            editable: false,
        },
        {
            field: 'itemFormula',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCalculation' && f.lanType === 'COL')[0].lanName
                    : '', //계산식
            editable: false,
            hide: true,
            cellStyle: { textAlign: 'center' },
            minWidth: 100,
        },
        {
            field: 'poAddItemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemQty' && f.lanType === 'COL')[0].lanName
                    : '', //발주수량
            editable: props.inputs.poStusNm === '입고완료' ? false : true,
            minWidth: 110,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'poItemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemBomQty' && f.lanType === 'COL')[0].lanName
                    : '', //수량(BOM)
            editable: true,
            minWidth: 110,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            editable: false,
            aggFunc: 'sum',
            cellClass: 'numberType',
        },
        {
            field: 'itemUnitNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '', //품목단위
            cellStyle: { textAlign: 'left' },
            editable: false,
            minWidth: 100,
        },
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', //기준단가
            editable: false,
            minWidth: 110,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            cellClass: 'numberType',
        },
        {
            field: 'poItemCost',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemCost' && f.lanType === 'COL')[0].lanName
                    : '', //발주단가(VAT포함)
            minWidth: 150,
            editable: false,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            cellClass: 'numberType',
        },
        {
            field: 'poForeignAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ForeignAmt' && f.lanType === 'COL')[0].lanName
                    : '', //외화금액
            minWidth: 110,
            editable: false,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            cellClass: 'numberType',
        },
        {
            field: 'poWonAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '', //원화금액
            minWidth: 110,
            editable: false,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            cellClass: 'numberType',
        },
        {
            field: 'itemVatYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemVatYn' && f.lanType === 'COL')[0].lanName
                    : '', //부가세여부
            editable: false,
            minWidth: 140,
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'poItemVat',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemVat' && f.lanType === 'COL')[0].lanName
                    : '', //부가세
            minWidth: 110,
            editable: false,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted + ' ';
            },
            cellStyle: { textAlign: 'right' },
            cellClass: 'numberType',
        },
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '', //규격1
            editable: false,
            cellStyle: { textAlign: 'center' },
            minWidth: 140,
        },
        {
            field: 'poRemarkDtl',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_RemarkDtl' && f.lanType === 'COL')[0].lanName
                    : '', //적요
            editable: true,
            cellStyle: { textAlign: 'center' },
            minWidth: 100,
        },
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '', //비고
            editable: true,
            cellStyle: { textAlign: 'center' },
            minWidth: 160,
        },
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드

            cellStyle: { textAlign: 'center' },
            minWidth: 100,
        },
    ];
    //폼안 거래처 설정
    const AuthGroupGridColumnDef = [
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래처명
        },
        {
            field: 'personCharg',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PersonCharg' && f.lanType === 'COL')[0].lanName
                    : '', //담당자
        },
        // {
        //   field: "arrivCustCd",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_ArrivCustCd" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //납품장소
        // },
    ];
    //디테일 그리드안 품목코드 설정
    const AuthGroupGridColumnDef1 = [
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장코드
        },
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            minWidth: 300,
        },
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '', //규격
            editable: true,
        },
        {
            field: 'itemFormula',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCalculation' && f.lanType === 'COL')[0].lanName
                    : '', //계산식
            hide: true,
        },
        {
            field: 'itemUnitNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '', //단위
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: props.inputs.comboUnit,
            },
            valueParser: (params) => {
                return props.inputs.comboValue;
            },
            valueFormatter: (params) => {
                if (params.value == undefined) {
                    return null;
                } else {
                    return params.value.name;
                }
            },
        },
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', //기준단가
            editable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StockQty' && f.lanType === 'COL')[0].lanName
                    : '', //재고수량
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
        },
    ];
    //재고체크 버튼 컬럼
    const AuthGroupGridColumnDef2 = [
        {
            field: 'stockDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SockDate' && f.lanType === 'COL')[0].lanName
                    : '', //재고일자
        },
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            minWidth: 300,
        },
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '', //규격1
            cellStyle: { textAlign: 'center' },
        },
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StockQty' && f.lanType === 'COL')[0].lanName
                    : '', //재고수량
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'usedQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UsedQty' && f.lanType === 'COL')[0].lanName
                    : '', //필요수량
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        {
            field: 'lossQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LossQty' && f.lanType === 'COL')[0].lanName
                    : '', //부족수량
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: (params) => {
                let paramsSplit = null;
                if (params.value) {
                    paramsSplit = params.value.toString().split(' ');
                    if (paramsSplit.length > 0 && paramsSplit[0] * 1 < 0) {
                        return { color: 'red' };
                    }
                }
            },
            cellStyle: { textAlign: 'right' },
        },
    ];
    //재고체크 안 품목코드설정
    const AuthGroupGridColumnDef3 = [
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            minWidth: 300,
        },
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '', //규격
            editable: true,
        },
        {
            field: 'itemFormula',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCalculation' && f.lanType === 'COL')[0].lanName
                    : '', //계산식
            hide: true,
        },
        {
            field: 'itemUnitNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '', //단위
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: props.inputs.comboUnit,
            },
            valueParser: (params) => {
                return props.inputs.comboValue;
            },
            valueFormatter: (params) => {
                if (params.value == undefined) {
                    return null;
                } else {
                    return params.value.name;
                }
            },
        },

        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', //기준단가
            editable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
        },
    ];
    let a = null;

    const AuthGroupSettingClicked = (_data) => {
        setSelectedRowData({ ..._data.data });
        // props.GetSalesOrderItemdtls(saveSoNo);
        setModalToggle(true);
        setCheckInputs({
            ...checkInputs,
            value: '',
        });
        props.setAuthGroupGridRowData([]);
    };
    const AuthGroupSettingClicked1 = (_data) => {
        a = _data.data;
        setModalToggle1(true);
    };
    const AuthGroupSettingClicked2 = (_data) => {
        setSelectedRowData({ ..._data.data });
        setModalToggle2(true);
        setCheckInputs({
            ...checkInputs,
            value: '',
        });
        props.setAuthGroupGridRowData([]);
    };
    const AuthGroupSettingClicked3 = (_data) => {
        setModalToggle3(true);
    };
    const AuthGroupSettingClicked4 = (_data) => {
        setModalToggle4(true);
    };
    const onCellClicked = (e) => {
        const selected = e.data;
        setSavePoNo(selected.poNo);
        console.log(selected);
        props.GetPurchaseOrderDtl(selected.poNo);
        props.setInputs({
            ...props.inputs,
            plantCd: selected.plantCd,
            poCreateDt: new Date(selected.poCreateDt),
            custCd: selected.custCd,
            custNm: selected.custNm,
            poNo: selected.poNo,
            createId: selected.createId,
            inWh: selected.inWh,
            delivDt: new Date(selected.delivDt),
            poType: selected.poType,
            poStusCd: selected.poStusCd,
            poStusNm: selected.poStusNm,
            plantCd: selected.plantCd,
            currencyNm: selected.currencyNm,
            arrivCustNm: selected.arrivCustNm,
            reference: selected.reference,
            filePath: selected.filePath,
            poDelivReqDt: new Date(selected.poDelivReqDt),
            no: selected.no,
        });
        no = selected.no;
    };
    const onCellClicked1 = (e) => {
        const selected = e.data;

        props.setChangedRowData1({
            ...props.setChangedRowData1,
            poNo: props.inputs.poNo,
            itemCd: selected.itemCd,
            itemNm: selected.itemNm,
            itemStd: selected.itemStd,
            poItemQty: selected.poItemQty,
            PoAddItemQty: selected.PoAddItemQty,
            itemUnit: selected.itemUnit,
            itemStdAmt: selected.itemStdAmt,
            arrivCustCd: selected.arrivCustCd,
            poItemCost: selected.poItemCost,
            poForeignAmt: selected.itemStdAmt * selected.poItemQty,
            poItemVat: selected.itemStdAmt * selected.poItemQty * 0.1,
            poRemarkDtl: selected.poRemarkDtl,
        });
    };
    const splitFun = (_poAddItemQty, _itemFormula) => {
        let ab = _poAddItemQty * 1;
        let c = '';
        let d = '';
        //숫자
        for (let i = 0; i < _itemFormula.length; i++) {
            if (i == _itemFormula.length - 1) {
                //마지막
                c = c + _itemFormula[i];
                if (d == '*') {
                    ab = ab * parseFloat(c);
                } else if (d == '/') {
                    ab = ab / parseFloat(c);
                } else if (d == '-') {
                    ab = ab - parseFloat(c);
                } else if (d == '+') {
                    ab = ab - parseFloat(c);
                } else {
                    ab = ab * parseFloat(c);
                }
                d = _itemFormula[i];
                c = '';
            } else {
                if (isNaN(_itemFormula[i]) == false || _itemFormula[i] === '.') {
                    //숫자면 string에 저장
                    c = c + _itemFormula[i];
                } else {
                    //기호면 총합(ab) 전에있던 기호 지금 숫자 연산
                    if (d == '*') {
                        ab = ab * parseFloat(c);
                    } else if (d == '/') {
                        ab = ab / parseFloat(c);
                    } else if (d == '-') {
                        ab = ab - parseFloat(c);
                    } else if (d == '+') {
                        ab = ab - parseFloat(c);
                    } else {
                        ab = ab * parseFloat(c);
                    }
                    d = _itemFormula[i];
                    c = '';
                }
            }
        }
        return ab.toFixed(2) * 1;
    };
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '45%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px' }}
                            selected={props.startDate}
                            onChange={(e) => {
                                props.setStartDate(e);
                            }}
                        />
                        ~
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginLeft: '5px' }}
                            selected={props.endDate}
                            onChange={(e) => {
                                props.setEndDate(e);
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {/* 재고체크 */}
                        <BasicButton
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Btn_CheckStock' && f.lanType === 'BTN'
                                      )[0].lanName
                                    : ''
                            }
                            onClick={(e) => {
                                AuthGroupSettingClicked3(e);
                            }}
                        />
                        {/* 인쇄 */}
                        <BasicButton
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Print' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : ''
                            }
                            onClick={() => props.Print()}
                        />
                        {/* 왼쪽그리드 버튼 */}
                        <AuthGroupButton
                            pageName="PM10010"
                            target="G01"
                            refreshNone="none"
                            selectFunc={() => {
                                props.SearchLogic();
                            }}
                            addFunc={() =>
                                // gridRef.current.api.setRowData([{}, ...props.rowData])
                                props.setModalToggle(true)
                            }
                            saveFunc={() => {
                                props.SaveConfirm();
                            }}
                            deleteFunc={() => props.DeleteConfirm()}
                        />
                    </div>
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    {/* 왼쪽 그리드 */}
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        defaultColDef={{
                            flex: 1,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        rowData={props.rowData}
                        rowSelection="multiple"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        onCellClicked={onCellClicked}
                        // suppressRowClickSelection={true}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        frameworkComponents={{
                            customHeaderRenderer: Commons.CustomHeaderRenderer,
                        }}
                        // onGridReady={onGridReady}
                        enableCellChangeFlash={true}
                        // suppressAggFuncInHeader={true}
                        // rowMultiSelectWithClick={true}
                        getRowStyle={(e) => {
                            GridFunctions.getRowStyle(e);
                        }}
                    />
                </div>
            </div>
            <div style={{ width: '55%' }}>
                <div>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <CardH3
                            wrapStyle={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_OrderInformation' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : ''
                            }
                        ></CardH3>
                        {/* 폼 버튼 */}
                        <AuthGroupButton
                            pageName="PM10010"
                            target="F01"
                            refreshNone="none"
                            // refreshFunc={() => {
                            //   props.Reset();
                            //   props.setSelectedRowData([]);
                            //   props.setRowData1([]);
                            // }}
                            addFunc={() => {
                                props.Reset();
                                props.setSelectedRowData([]);
                                props.setRowData1([]);
                            }}
                            saveFunc={() => {
                                if (!props.inputs.arrivCustNm) {
                                    props.setSnackbars({
                                        toggle: true,
                                        type: 'info',
                                        message: props.lanData.filter(
                                            (f) => f.lanId === 'Snack_CheckArrivCustNm' && f.lanType === 'SNACK'
                                        )[0].lanName,
                                    });
                                    return false;
                                } else {
                                    props.SaveConfirm('save');
                                }
                            }}
                            deleteFunc={() => props.DeleteConfirm()}
                        />
                    </Card>
                    <Section />
                    <Card style={{ height: '240px', marginTop: '0px' }}>
                        <FormGroup
                            columnCount={3}
                            datas={[
                                {
                                    type: 'date',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_OrderDate' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //발주일자
                                    value: props.inputs.poCreateDt,
                                    onChange: (e) => {
                                        props.setInputs({
                                            ...props.inputs,
                                            poCreateDt: e,
                                        });
                                    },
                                },
                                {
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_CustNm' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //거래처명
                                    value: props.inputs.custNm ? props.inputs.custNm : '',
                                    onChange: (e) => {
                                        props.setInputs({
                                            ...props.inputs,
                                            custNm: e.target.value,
                                        });
                                    },
                                    clicked: true,
                                    onClick: (e) => {
                                        if (props.inputs.poNo == '') {
                                            AuthGroupSettingClicked(e);
                                            props.setInputs({
                                                ...props.inputs,

                                                //custNm: "",
                                            });
                                            props.setRowData1([]);
                                        }
                                    },
                                    readOnly: true,
                                },
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_PoNo' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //발주번호
                                    inputClass: 'input',
                                    value: props.inputs.poNo ? props.inputs.poNo : '',
                                    onChange: (e) => {
                                        let { value } = { ...e.target };
                                        props.setInputs({
                                            ...props.inputs,
                                            poNo: value,
                                        });
                                    },
                                    readOnly: true,
                                },
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_PersonCharg' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //담당자
                                    inputClass: 'input',
                                    value: props.inputs.createId ? props.inputs.createId : '',
                                    onChange: (e) => {
                                        let { value } = { ...e.target };
                                        props.setInputs({
                                            ...props.inputs,
                                            createId: value,
                                        });
                                    },
                                    readOnly: true,
                                },
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_CurrencyNm' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //거래통화
                                    value: props.inputs.currencyNm ? props.inputs.currencyNm : '',

                                    readOnly: true,
                                },
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_CdGubun' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //결제유형
                                    value: props.inputs.poType ? props.inputs.poType : '',

                                    readOnly: true,
                                },
                                {
                                    type: 'date',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_SoDueDt' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //납기일
                                    value: props.inputs.delivDt,
                                    onChange: (e) => {
                                        props.setInputs({
                                            ...props.inputs,
                                            delivDt: e,
                                        });
                                    },
                                },
                                {
                                    type: 'date',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_PoDelivReqDt' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //납기요청일
                                    value: props.inputs.poDelivReqDt,
                                    onChange: (e) => {
                                        props.setInputs({
                                            ...props.inputs,
                                            poDelivReqDt: e,
                                        });
                                    },
                                },
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_ArriveCustName' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //납품장소
                                    inputClass: 'input',
                                    value: props.inputs.arrivCustNm ? props.inputs.arrivCustNm : '',
                                    onChange: (e) => {
                                        props.setInputs({
                                            ...props.inputs,
                                            arrivCustNm: e.target.value,
                                        });
                                    },
                                    clicked: true,
                                    onClick: (e) => {
                                        AuthGroupSettingClicked2(e);
                                        props.setInputs({
                                            ...props.inputs,
                                        });
                                        props.setRowData1([]);
                                    },
                                    readOnly: true,
                                },
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_reference' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //참조
                                    inputClass: 'input',
                                    value: props.inputs.reference ? props.inputs.reference : '',
                                    onChange: (e) => {
                                        let { value } = { ...e.target };
                                        props.setInputs({
                                            ...props.inputs,
                                            reference: value,
                                        });
                                    },
                                },
                            ]}
                        />
                    </Card>
                    <Section />
                </div>

                <div>
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {/* 오른쪽 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="PM10010"
                            target="G02"
                            refreshNone="none"
                            addFunc={() => {
                                if (props.rowData1.length === 0) {
                                    props.setAuthGroupGridRowData1([]);
                                    setCheckInputs({
                                        value1: '',
                                    });
                                    gridRef1.current.api.setRowData([{}, ...props.rowData1]);
                                } else if (props.rowData1[0].poItemQty) {
                                    props.setAuthGroupGridRowData1([]);
                                    setCheckInputs({
                                        value1: '',
                                    });
                                    gridRef1.current.api.setRowData([{}, ...props.rowData1]);
                                } else {
                                    props.setAuthGroupGridRowData1([]);
                                    setCheckInputs({
                                        value1: '',
                                    });
                                    props.setAddEventController('1');
                                }
                            }}
                            saveFunc={() => {
                                props.SaveConfirm();
                                // for (let i = 0; i < props.rowData1.length; i++) {
                                //   if (
                                //     props.rowData1[i].whCd === undefined &&
                                //     !props.rowData1[i].whNm
                                //   ) {
                                //     props.setSnackbars({
                                //       toggle: true,
                                //       type: "info",
                                //       message: props.lanData.filter(
                                //         (f) =>
                                //           f.lanId === "Snack_CheckInWh" && f.lanType === "SNACK"
                                //       )[0].lanName,
                                //     });
                                //     return false;
                                //   } else if (
                                //     props.rowData1[i].poItemQty === undefined ||
                                //     props.rowData1[i].poAddItemQty === NaN
                                //   ) {
                                //     props.setSnackbars({
                                //       toggle: true,
                                //       type: "info",
                                //       message: props.lanData.filter(
                                //         (f) =>
                                //           f.lanId === "Snack_CheckQty" && f.lanType === "SNACK"
                                //       )[0].lanName,
                                //     });
                                //     return false;
                                //   } else {
                                //     props.SaveConfirm();
                                //   }
                                // }
                            }}
                            deleteFunc={() => {
                                props.DeleteConfirm('G02');
                            }}
                        />
                    </Card>
                    <Section />
                    <Card style={{ height: '70px', marginTop: '0px' }}>
                        {/* 거래 통화 폼 */}
                        <FormGroup
                            className="formGroup_info_box"
                            columnCount={3}
                            datas={[
                                {
                                    type: 'combo',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_CurrencyNm' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //거래통화
                                    combos: props.inputs.comboCurrencyCd,
                                    value: props.inputs.currencyCd,
                                    onChange: (e) => {
                                        props.setInputs({
                                            ...props.inputs,
                                            currencyCd: e,
                                        });
                                    },
                                },
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_CurrencyAmt' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //환율
                                    value:
                                        props.inputs.currencyCd === 'CU_02'
                                            ? 1
                                            : props.totalInputs.currencyAmt
                                            ? props.totalInputs.currencyAmt
                                            : 1,
                                    inputType: 'number',
                                    onChange: (e) => {
                                        let { value } = { ...e.target };
                                        props.setTotalInputs({
                                            ...props.totalInputs,
                                            currencyAmt: value,
                                        });
                                    },
                                },
                            ]}
                        />
                    </Card>
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '380px' }}>
                        {/* 오른쪽 그리드 */}
                        <AgGridReact
                            ref={gridRef1}
                            animateRows={true}
                            columnDefs={columnDefs1}
                            groupIncludeFooter={true}
                            groupIncludeTotalFooter={true}
                            // excelStyles={excelStyles}
                            defaultColDef={{
                                flex: 1,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            autoGroupColumnDef={autoGroupColumnDef}
                            onCellValueChanged={(e) => {
                                if (e.oldValue !== e.newValue) {
                                    props.rowData1.map((item, index) => {
                                        if (item.itemCd === e.data.itemCd) {
                                            if (item.itemFormula == '1') {
                                                item.poItemQty = item.poAddItemQty;
                                            } else {
                                                item.poItemQty = Commons.splitFun(item.poAddItemQty, item.itemFormula);
                                            }
                                            item.poForeignAmt =
                                                props.inputs.currencyCd == 'CU_02'
                                                    ? 0
                                                    : e.data.itemVatYn === 'Y'
                                                    ? item.poItemCost * e.data.poItemQty
                                                    : item.itemStdAmt * e.data.poItemQty; //외화금액
                                            item.poWonAmt =
                                                e.data.itemVatYn === 'Y'
                                                    ? item.poItemCost * e.data.poItemQty * props.totalInputs.currencyAmt
                                                    : item.itemStdAmt *
                                                      e.data.poItemQty *
                                                      props.totalInputs.currencyAmt; //원화금액
                                            item.poItemVat =
                                                e.data.itemVatYn === 'Y'
                                                    ? item.itemStdAmt *
                                                      e.data.poItemQty *
                                                      props.totalInputs.currencyAmt *
                                                      0.1
                                                    : 0; //부가세
                                        }
                                    });
                                    props.setChangedRowData1((current) => [...current]);
                                }
                            }}
                            rowData={props.rowData1}
                            rowSelection="multiple"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData1)
                            }
                            // onCellClicked={onCellClicked1}
                            getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                        />
                    </div>
                </div>
            </div>
            {/* 거래처 팝업 */}
            {modalToggle && (
                <GridModal
                    conditions={[
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Dia_CustCd' && f.lanType === 'DIALOG')[0]
                                          .lanName
                                    : '', //거래처 코드
                            value: checkInputs.value,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    value: e.target.value,
                                });
                            },
                            onClick: (e) => {
                                // document.getElementsByName("품목코드/명").focus;
                            },
                            onKeyDown: (e) => {
                                props.CustNmHelper(checkInputs.value, 'N');
                            },
                        },
                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '', //조회
                            onClick: (e) => {
                                props.CustNmHelper(checkInputs.value, 'N');
                            },
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter(
                                  (f) => f.lanId === 'Dia_OrderInputSettings' && f.lanType === 'DIALOG'
                              )[0].lanName
                            : ''
                    }
                    onClose={() => setModalToggle(false)}
                    gridColumn={AuthGroupGridColumnDef}
                    gridRowData={props.authGroupGridRowData}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                plantCd: e[i].plantCd,
                                custCd: e[i].custCd,
                                custNm: e[i].custNm,
                                arrivCustCd: e[i].arrivCustCd,
                                currencyNm: e[i].currencyNm,
                            });
                        }
                        setSelectedModalData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        if (selectedModalData) {
                            props.setInputs({
                                ...props.inputs,
                                plantCd: selectedModalData[0].plantCd,
                                custCd: selectedModalData[0].custCd,
                                custNm: selectedModalData[0].custNm,
                                // arrivCustCd: selectedModalData[0].arrivCustCd,
                                currencyNm: selectedModalData[0].currencyNm,
                            });
                        }
                    }}
                />
            )}
            {/* 오른쪽 그리드 안 품목 팝업 */}
            {modalToggle1 && (
                <GridModal
                    conditions={[
                        {
                            type: 'combo',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ItemType' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '', //품목타입
                            combos: props.inputs.comboList.filter((x) => x.value != 'ITEM_TYPE_01'),
                            value: props.checkInputs.itemType,
                            onChange: (e) => {
                                props.setCheckInputs({
                                    ...checkInputs,
                                    itemType: e,
                                });
                            },
                        },
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ItemCode/Name' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '', //품목코드/명
                            value: checkInputs.value1,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    value1: e.target.value,
                                });
                            },
                            onClick: (e) => {
                                // document.getElementsByName("품목코드/명").focus;
                            },
                            onKeyDown: (e) => {
                                props.GetCommonItemList(checkInputs.value1, '2');
                            },
                        },
                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '', //조회
                            onClick: (e) => {
                                props.GetCommonItemList(checkInputs.value1, '2');
                            },
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter(
                                  (f) => f.lanId === 'Dia_ItemCodeSetting' && f.lanType === 'DIALOG'
                              )[0].lanName
                            : '' //품목코드 설정
                    }
                    onClose={() => setModalToggle1(false)}
                    gridColumn={AuthGroupGridColumnDef1}
                    gridRowData={props.authGroupGridRowData1}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                            : '' //저장
                    }
                    onCellValueChanged={(e) => {
                        GridFunctions.onCellValueChanged(e, AuthGroupGridColumnDef1, props.setChangedRowData1);
                    }}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                plantCd: e[i].plantCd,
                                itemCd: e[i].itemCd,
                                itemNm: e[i].itemNm,
                                itemStd: e[i].itemStd,
                                itemUnit: e[i].itemUnit,
                                itemUnitNm: e[i].itemUnitNm,
                                itemStdAmt: e[i].itemStdAmt,
                                poItemCost: e[i].poItemCost,
                                itemVatYn: e[i].itemVatYn,
                                itemFormula: e[i].itemFormula,
                            });
                        }
                        setSelectedModalData1(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={(e) => {
                        let a = gridRef1.current.props.rowData;
                        let index = -1;
                        for (let i = 0; i < props.authGroupGridRowData1.length; i++) {
                            if (props.authGroupGridRowData1[i].itemCd === selectedModalData1[0].itemCd) {
                                index = i;
                            }
                        }
                        if (props.authGroupGridRowData1.length > 0) {
                            props.setRowData1([
                                ...props.rowData1,
                                {
                                    itemCd: props.authGroupGridRowData1[index].itemCd,
                                    itemNm: props.authGroupGridRowData1[index].itemNm,
                                    itemStdAmt: props.authGroupGridRowData1[index].itemStdAmt,
                                    poItemCost:
                                        props.authGroupGridRowData1[index].itemVatYn === 'Y'
                                            ? props.authGroupGridRowData1[index].itemStdAmt * 0.1 +
                                              props.authGroupGridRowData1[index].itemStdAmt
                                            : 0,
                                    plantCd: props.authGroupGridRowData1[index].plantCd,
                                    itemStd: props.authGroupGridRowData1[index].itemStd,
                                    itemUnitNm: props.authGroupGridRowData1[index].itemUnitNm,
                                    itemVatYn: props.authGroupGridRowData1[index].itemVatYn,
                                    itemFormula: props.authGroupGridRowData1[index].itemFormula,
                                },
                            ]);
                        }
                    }}
                />
            )}
            {/* 폼 안에 납품장소 팝업 */}
            {modalToggle2 && (
                <GridModal
                    conditions={[
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Dia_CustCd' && f.lanType === 'DIALOG')[0]
                                          .lanName
                                    : '', //거래처코드
                            value: checkInputs.value,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    value: e.target.value,
                                });
                            },
                            onClick: (e) => {
                                // document.getElementsByName("품목코드/명").focus;
                            },
                            onKeyDown: (e) => {
                                props.CustNmHelper(checkInputs.value, 'Y');
                            },
                        },
                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '', //조회
                            onClick: (e) => {
                                props.CustNmHelper(checkInputs.value, 'Y');
                            },
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter(
                                  (f) => f.lanId === 'Dia_DeliveryLocationSetting' && f.lanType === 'DIALOG'
                              )[0].lanName
                            : '' //납품장소 설정
                    }
                    onClose={() => setModalToggle2(false)}
                    gridColumn={AuthGroupGridColumnDef}
                    gridRowData={props.authGroupGridRowData}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                            : '' //저장
                    }
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                plantCd: e[i].plantCd,
                                custCd: e[i].custCd,
                                custNm: e[i].custNm,
                                arrivCustCd: e[i].arrivCustCd,
                                currencyNm: e[i].currencyNm,
                            });
                        }
                        setSelectedModalData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        props.setInputs({
                            ...props.inputs,
                            arrivCustCd: selectedModalData[0].custCd,
                            arrivCustNm: selectedModalData[0].custNm,
                        });
                    }}
                />
            )}
            {/* 재고 체크 팝업 */}
            {modalToggle3 && (
                <GridModal
                    conditions={[
                        {
                            type: 'button',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ItemChose' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '', //품목선택
                            onClick: (e) => {
                                props.setCheckInputs1({
                                    ...props.checkInputs1,
                                    value1: '',
                                });
                                props.setAuthGroupGridRowData3([]);
                                AuthGroupSettingClicked4(e);
                            },
                        },
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Dia_ItemNm' && f.lanType === 'DIALOG')[0]
                                          .lanName
                                    : '', //품목명
                            value: checkInputs1.value,
                            disabled: true,
                            readOnly: true,
                        },
                        {
                            type: 'input',
                            inputType: 'number',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Dia_Number' && f.lanType === 'DIALOG')[0]
                                          .lanName
                                    : '', //수량
                            value: checkInputs1.value1,
                            onChange: (e) => {
                                setCheckInputs1({
                                    ...checkInputs1,
                                    value1: e.target.value,
                                });
                            },
                            onClick: (e) => {
                                // document.getElementsByName("품목코드/명").focus;
                            },
                            onKeyDown: (e) => {
                                props.CheckStockLogic(checkInputs1.value2, checkInputs1.value1);
                            },
                        },
                    ]}
                    containerStyle={{ width: '1200px' }}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Dia_StockCheck' && f.lanType === 'DIALOG')[0]
                                  .lanName
                            : '' //재고체크
                    }
                    onClose={() => setModalToggle3(false)}
                    gridColumn={AuthGroupGridColumnDef2}
                    gridRowData={props.authGroupGridRowData2}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Dia_StockCheck' && f.lanType === 'DIALOG')[0]
                                  .lanName
                            : '' //재고체크
                    }
                    onCellValueChanged={(e) => {
                        GridFunctions.onCellValueChanged(e, AuthGroupGridColumnDef1, props.setChangedRowData1);
                    }}
                    gridOnClick={(e) => {
                        let data = [];
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={(e) => {
                        props.CheckStockLogic(checkInputs1.value2, checkInputs1.value1);
                    }}
                    execCLosed="2"
                />
            )}
            {/* 재고체크 안 품목 팝업 */}
            {modalToggle4 && (
                <GridModal
                    conditions={[
                        {
                            type: 'combo',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ItemType' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '', //품목타입
                            combos: props.checkInputs1.comboList,
                            value: props.checkInputs1.itemType,
                            onChange: (e) => {
                                props.setCheckInputs1({
                                    ...props.checkInputs1,
                                    itemType: e,
                                });
                            },
                        },
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ItemCode/Name' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '', //품목코드/명
                            value: props.checkInputs1.value1,
                            onChange: (e) => {
                                props.setCheckInputs1({
                                    ...props.checkInputs1,
                                    value1: e.target.value,
                                });
                            },
                            onClick: (e) => {
                                // document.getElementsByName("품목코드/명").focus;
                            },
                            onKeyDown: (e) => {
                                props.GetCommonItemList(props.checkInputs1.value1, '1');
                            },
                        },
                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '', //조회
                            onClick: (e) => {
                                props.GetCommonItemList(props.checkInputs1.value1, '1');
                            },
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter(
                                  (f) => f.lanId === 'Dia_ItemCodeSetting' && f.lanType === 'DIALOG'
                              )[0].lanName
                            : '' //품목코드 설정
                    }
                    onClose={() => setModalToggle4(false)}
                    gridColumn={AuthGroupGridColumnDef3}
                    gridRowData={props.authGroupGridRowData3}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Choice' && f.lanType === 'BTN')[0].lanName
                            : '' //선택
                    }
                    onCellValueChanged={(e) => {
                        GridFunctions.onCellValueChanged(e, AuthGroupGridColumnDef1, props.setChangedRowData1);
                    }}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                plantCd: e[i].plantCd,
                                itemCd: e[i].itemCd,
                                itemNm: e[i].itemNm,
                                itemStd: e[i].itemStd,
                                itemUnit: e[i].itemUnit,
                                itemUnitNm: e[i].itemUnitNm,
                                itemStdAmt: e[i].itemStdAmt,
                                poItemCost: e[i].poItemCost,
                                itemVatYn: e[i].itemVatYn,
                                itemFormula: e[i].itemFormula,
                            });
                        }
                        setSelectedModalData2(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={(e) => {
                        setCheckInputs1({
                            ...checkInputs1,
                            value2: selectedModalData2[0].itemCd,
                            value: selectedModalData2[0].itemNm,
                        });
                    }}
                />
            )}
        </div>
    );
}

export default PM10010;
